export default "__VITE_ASSET__CHIBxzPj__"